import { ColumnConfig } from '../hooks/useTablePreferences';

export const wellnessItemEntryColumns: ColumnConfig[] = [
  { key: 'title', label: 'Title', defaultWidth: 130, minWidth: 80, visible: true, sortable: true, resizable: true },
  { key: 'wellnessItem', label: 'Wellness Item', defaultWidth: 140, minWidth: 80, visible: true, sortable: true, resizable: true },
];
